import { narration } from './narration.js';

export function element(tag, text, className) {
  const el = document.createElement(tag);
  if (text !== undefined) el.textContent = text;
  if (className) el.className = className;
  return el;
}
export function button(text, onClick, className = 'learning-btn') {
  const el = element('button', text, className);
  el.type = 'button';
  el.addEventListener('click', onClick);
  return el;
}
export function briefSummary(site) {
  return site.summary.split('。').slice(0, 2).join('。') + '。';
}
export function speechButton(id, text) {
  const b = button(narration.activeId === id ? '■ 読み上げ停止' : '読み上げ', () => narration.speak(id, text));
  b.dataset.readId = id;
  b.disabled = !narration.supported;
  b.setAttribute('aria-pressed', String(narration.activeId === id));
  if (!narration.supported) b.title = narration.message;
  return b;
}
export function sourceLinks(site) {
  const list = element('ul', undefined, 'source-links');
  for (const url of site.sources ?? []) {
    const item = element('li');
    const link = element('a', new URL(url).hostname);
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    item.append(link);
    list.append(item);
  }
  return list;
}
export function selectControl(label, options, value, onChange) {
  const wrap = element('label', undefined, 'learning-field');
  wrap.append(element('span', label));
  const select = document.createElement('select');
  select.setAttribute('aria-label', label);
  for (const [key, name] of options) {
    const opt = element('option', name);
    opt.value = key;
    select.append(opt);
  }
  select.value = value;
  select.addEventListener('change', () => onChange(select.value));
  wrap.append(select);
  return wrap;
}
// One subscription; removed DOM buttons do not leave listeners behind.
narration.subscribe(() => {
  if (typeof document === 'undefined') return;
  for (const b of document.querySelectorAll('[data-read-id]')) {
    const playing = narration.activeId === b.dataset.readId;
    b.textContent = playing ? '■ 読み上げ停止' : '読み上げ';
    b.setAttribute('aria-pressed', String(playing));
  }
  for (const status of document.querySelectorAll('[data-speech-status]')) status.textContent = narration.message;
});
